/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './index.css';
import { isMobileOrTablet } from "../../components/Utils/index";
import parser from "html-react-parser";

function WhyEai({angelAiLink, sunwestLink, sunwestLink1}) {
    const imgCDNURL = process.env.REACT_APP_CDN_URL + "eaimortgage/images/";
    const [imageSrc, setImageSrc] = useState("");

    useEffect(() => {
        // Determine which image to load based on device type
        const selectedImage = isMobileOrTablet() ? "whyeai-mob.webp" : "whyeai-banner.webp";
        setImageSrc(imgCDNURL + selectedImage);
    }, []);

    return (
        <section className="whyEai-section">
            <Container>
                <h1 className="whyEai-heading">Why EvolutionAI</h1>
                <Row className="whyEai-row">
                    <Col lg={6} md={12} sm={12} className="whyEai-column">
                        <p className="whyEai-para">
                            EvolutionAI Mortgage, Powered by {parser(sunwestLink)} is a revolutionary new way to buy a home that combines the amazing and fast power of {parser(angelAiLink)}  with the human touch of a real loan officer. Together they will guide you on your homebuying journey every step of the way.
                            <br /><br />
                            {parser(sunwestLink1)} is a full service mortgage banker that has been helping homebuyers just like you since 1980 - across the nation in all 50 states, District of Columbia, Puerto Rico, and the U.S. Virgin Islands. Our commitment to our core values of people, experience, technology, and product stem from the values that {parser(sunwestLink1)} was built on. It is this culture of excellence that has helped us grow, and even allowed us to weather through tough economic times and continue to offer you exceptional customer service.
                            <br /><br />
                            We strive to offer our customers not only competitive mortgage rates, but also a wide selection of mortgage products including Conventional, FHA, VA, Jumbo, Home Improvements, and Reverse mortgages – we'll help you choose the perfect one for you!
                        </p>
                    </Col>
                    <Col lg={6} md={12} sm={12} className="whyEai-column-img">
                        <img
                            src={imageSrc}
                            alt="Why EvolutionAI"
                            className="whyEai-img"
                        />
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default WhyEai;
